import React from 'react';

export default function ChevronLeftIcon() {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5 20L15 10L5 0V2L13 10L5 18V20Z"
				transform="scale(-1, 1) translate(-20, 0)"
			/>
		</svg>
	);
}
